import React, {FC, FormEvent, useReducer} from "react";

import Input from "./Input";
import Modal from "./Modal";
import {RenderObjectTypes} from "../lib/Types";

export type LineState = {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    stroke: string;
    fill: string;
    type: RenderObjectTypes.LINE
};
type Action = { type: string, payload: object };


const lineState: LineState = {
    x1: 0,
    y1: 0,
    x2: 100,
    y2: 100,
    stroke: "#004cff",
    fill: "",
    type: RenderObjectTypes.LINE
};

function lineReducer(state: LineState, action: Action) {
    switch (action.type) {
        case "setParams":
            return {...state, ...action.payload};
        default:
            throw new Error();
    }
}

interface CreateLineModalProps {
    onCreate: (line: LineState) => void;
    onHide: () => void;
}

export const CreateLineModal: FC<CreateLineModalProps> = ({
                                                              onCreate,
                                                              onHide
                                                          }) => {
    const [line, lineDispatch] = useReducer(lineReducer, lineState);
    const addLine = (e: FormEvent) => {
        e.preventDefault();
        onCreate(line);
        onHide();
    };
    const onChangeRect = (params: object) => lineDispatch({
        type: "setParams",
        payload: {...line, ...params}
    });
    const changeX1 = (x1: string) => onChangeRect({x1: Number(x1)});
    const changeY1 = (y1: string) => onChangeRect({y1: Number(y1)});
    const changeX2 = (x2: string) => onChangeRect({x2: Number(x2)});
    const changeY2 = (y2: string) => onChangeRect({y2: Number(y2)});
    const changeStroke = (stroke: string) => onChangeRect({stroke: stroke});
    const changeFill = (fill: string) => onChangeRect({fill: fill});
    return (
        <Modal title="Set Line Params" onHide={onHide}>
            <form onSubmit={addLine}>
                <Input label="x1" type="number" value={String(line.x1)} onChange={changeX1}/>
                <Input label="y1" type="number" value={String(line.y1)} onChange={changeY1}/>
                <Input label="x2" type="number" value={String(line.x2)} onChange={changeX2}/>
                <Input label="y2" type="number" value={String(line.y2)} onChange={changeY2}/>
                <Input label="stroke" type="color" value={String(line.stroke)} onChange={changeStroke}/>
                <Input label="fill" type="color" value={String(line.fill)} onChange={changeFill}/>
                <button type="submit">Add Line</button>
            </form>
        </Modal>
    );
};